import { Injectable, InjectionToken, Injector } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ComponentPortal, ComponentType, Portal } from '@angular/cdk/portal';
import { from, Subject, Subscription } from 'rxjs';

export const MAT_DRAWER_DATA: InjectionToken<any> = new InjectionToken('data');

/** Borrowed from https://stackblitz.com/edit/mat-dynamic-panel?file=src%2Fapp%2Fapp.component.ts */
@Injectable({
    providedIn: 'root',
})
export class MobileMenuService {
    /** Subscription to stuff happening when it closes */
    closeSubscription!: Subscription;
    /** Behavior subj to help with when it closes */
    whenClosed = new Subject<any | null>();

    /** The drawer itself */
    menuDrawer!: MatSidenav;
    /** The drawer portal, helps w rendering dynamic component */
    private menuDrawerPortal$ = new Subject<Portal<any> | null>();

    /** Retrieves the current drawer portal as an `Observable`. */
    get drawerPortal() {
        return from(this.menuDrawerPortal$);
    }

    /**
     * Call this._drawer.open to open the drawer from anywhere.
     *
     * @param componentRef is the Component you want to render in the drawer
     * @param data is like MAT_DIALOG_DATA; it can be an object with any type that you send in to the component
     */
    open(componentRef: ComponentType<any>, data: any = null) {
        // this is necessary to send in extra data from caller to rendered component
        const injector = Injector.create({
            providers: [
                {
                    provide: MAT_DRAWER_DATA,
                    useValue: data,
                },
            ],
        });
        this.menuDrawerPortal$.next(
            new ComponentPortal(componentRef, null, injector),
        );

        // // set up the subscription for when it closes
        this.closeSubscription = this.menuDrawer.closedStart.subscribe(() => {
            // this.whenClosed.next(this.resultData);
        });
        this.menuDrawer.open();
        return this.whenClosed;
    }

    /** Closes the drawer and sets any response data to send to listening components. */
    close(result: any = null) {
        // this.resultData = result;
        // close the drawer and remove the close listener subscription
        this.menuDrawer.close().then(() => {
            this.closeSubscription.unsubscribe();
        });
    }
}
